import { nextSunday as nextSundayFns } from 'date-fns';

export default function nextSunday(date: Date): Date {
  return nextSundayFns(date);
}
